import styled, { css } from 'styled-components';
import { openedOverflow, openedWidth, transition } from './helpers';

export const ContentWrap = styled.div`
  flex-grow: 1;
  ${transition}
  
  ${({ isOpened }) => css`
    @media (max-width: 992px) {
      width: ${openedWidth(isOpened, 'auto')};
      overflow: ${openedOverflow(isOpened)};
      max-height: ${isOpened ? 'unset' : '0px'};
    }
  `};
`;
